import React from 'react';

import * as Sentry from '@sentry/react';

import { noopCallback } from '@looko-corp/acloset-react-kit';

import * as ASentry from '@/thirdparty/ASentry';
import { useNetworkErrorObserverEffect } from '@/axios/hooks/useNetworkErrorObserverEffect';
import { useNotAllowedMethodEffect } from '@/axios/hooks/useNotAllowedMethodEffect';
import { useUserAuth } from '@/state/cookieContext';

import { useEnableAnalyticsEffect } from './analytics/use-enable-analytics-effect';

export const AppSideEffectProvider = React.memo(function AppSideEffectProvider() {
  useSentryEffect();

  useEnableAnalyticsEffect();

  useNotAllowedMethodEffect();

  useNetworkErrorObserverEffect();

  return null;
});

const useSentryEffect = () => {
  const userAuth = useUserAuth();

  React.useEffect(() => {
    if (userAuth == null) {
      return;
    }

    // XXX: Production looko_qa 샵
    if (userAuth.userID === 1985850) {
      import('@sentry/react')
        .then(lazyLoadedSentry => {
          Sentry.addIntegration(lazyLoadedSentry.replayIntegration());
        })
        .catch(noopCallback);
    }

    ASentry.setUser({
      id: `${userAuth.userID}`,
      roles: `${userAuth.roles}`,
      username: userAuth.decodeToken.username,
    });
  }, [userAuth]);
};
